var spanish = {
    linkAvisoLegal: "https://www.ifema.es/aviso-legal",
    linkPoliticaPriv: "https://www.ifema.es/politica-privacidad",
    linkPoliticaCookies: "https://www.ifema.es/politica-cookies",
    linkAccesibilidad: "https://www.ifema.es/accesibilidad",
    expositor: "Expositores",
    misfavoritos: "Favoritos",
    guardaFav: "Guardar como favorito",
    privPolicy: "Política de privacidad",
    cookiePolicy: "Política de cookies",
    accesibilidad: "Accesibilidad",
    //mapa: "Planos",
    mapa: "Planos",
    avisolegal: "Aviso legal",
    ayuda: "Ayuda",
    tituloExpositores: "Lista de Empresas Participantes",
    datosActualizados: "Datos actualizados a 5 de Abril",
    todasEmpresas: "Todas las empresas",
    pais: "País/Provincia",
    sector: "Sector",
    actividad: "Actividad",
    producto: "Producto",
    representadas: "Representadas",
    marcas: "Marcas",
    específicos: "Específicos",
    favoritos: "Favoritos",
    cita: "Solicitar cita",
    buscar: "Buscar",
    resultadosPorPagina: "Resultados por página: ",
    //planoRecinto: "Plano del Recinto",
    //planoRecinto: "Plano interactivo del recinto - Pinche en cada pabellón para verlo en detalle",
    planoRecinto: "Plano interactivo del recinto",
    fichaEmpresa: "Ficha de Empresa",
    resultadosTodos: "Todos",
    tituloDescripcion: "Descripción",
    tituloIndiceFichero: "Información adicional",
    tituloIndiceSector: "Sectores",
    tituloIndiceProductos: "Productos",
    tituloIndiceActividades: "Actividades",
    tituloIndiceDestacados: "Productos Destacados",
    tituloIndiceMarcas: "Marcas",
    tituloIndiceStands: "Stands",
    tituloActividad: "Actividades",
    tituloProducto: "Productos",
    tituloIndiceRepresentadas: "Empresas Representadas",
    tituloIndiceRepresentadasPor: "Empresas que le representan",
    tituloIndicePaisesRepre: "Países representados ",
    tituloIndiceCoexpos: "Coexpositores ",
    tituloIndiceCampos: "Datos adicionales",
    tituloIndicePais: "Países",
    verEmpresas: "Ver Empresas",
    titular:"titular",
    direccion: "Dirección:",
    telefono: "Tel:",
    email: "Email:",
    mailto: "Enviar email",
    web: "Web:",
    video: "Video:",
    verVideo: "Ver video",
    pabellon: "Pabellón",
    tipoExpo: "EXPOSITOR",
    tipoCoexpo: "COEXPOSITOR",
    tipoRepre: "REPRESENTADA",
    tipoMarca: "MARCA",
    paisCatalogo: "País:",
    txtBusquedas: "Búsquedas",
    txtBusquedasAplicadas: "Búsquedas aplicadas",
    mostrarFavorito: "Mostrar favoritos",
    txtNoFicha: "Datos de la empresa no disponibles para este Catálogo",
    avisoLegal: "Todos los derechos reservados.<br><br>Todo el contenido inclu&iacute;do en esta aplicaci&oacute;n est&aacute; protegido por copyright y no puede ser reproducido sin la previa autorizaci&oacute;n de sus respectivos propietarios.<br><br>Queda prohibida la reproducci&oacute;n total o parcial de la aplicaci&oacute;n sin el permiso previo de los titulares IFEMA.<br>Copyright &copy; 2014 <br><br><strong>IFEMA - Feria de Madrid</strong><br>",
    avisoLegalWeb: "www.ifema.es",
    webIfema: "http://www.ifema.es",
    imprLista: "¿Desea imprimir las empresas para el filtro seleccionado?",
    imprLista1: "Número de empresas encontradas:",
    imprLista2: "¿Desea imprimir todas las empresas existentes para ese criterio o sólo las que estaba visualizando?",
    imprListaprimeras: "Imprimir las primeras",
    imprListaTodas: "Imprimir todas",
    imprCancelar: "Cancelar",
    imprFicha: "¿Desea imprimir la ficha de la empresa?",
    imprimir: "Imprimir",
    imprFavoritas: "¿Desea imprimir todas las empresas marcadas como favoritas?",
    imprPlano: "¿Desea imprimir el plano de la Feria?",
    imprPabellon: "¿Desea imprimir el plano del pabellón?",
    cerrar: "Cerrar",
    textoSinDatos: "Datos próximamente disponibles"
};
var english = {
    linkAvisoLegal: "https://www.ifema.es/en/legal-notice",
    linkPoliticaPriv: "https://www.ifema.es/en/privacy-policy",
    linkPoliticaCookies: "https://www.ifema.es/en/cookies-policy",
    linkAccesibilidad: "https://www.ifema.es/en/accessibility",
    expositor: "Exhibitors",
    privPolicy: "Privacy policy",
    cookiePolicy: "Cookies policy",
    accesibilidad: "Accessibility",
    misfavoritos: "Favourites",
    guardaFav: "Save as favourite",
    //mapa: "Floor Plan",
    mapa: "Interactive floor plan",
    avisolegal: "Legal notice",
    ayuda: "Help",
    tituloExpositores: "List of companies",
    datosActualizados: "Last update on 5 April",
    todasEmpresas: "All companies",
    pais: "Country/Region",
    sector: "Sector",
    actividad: "Activity",
    producto: "Product",
    representadas: "Represented",
    marcas: "Trademarks",
    específicos: "Specifics",
    favoritos: "Favourites",
    cita: "Request an appointment",
    buscar: "Search",
    resultadosPorPagina: "Results per page: ",
    //planoRecinto: "Exhibition floor plan",
    planoRecinto: "Exhibition floor plan – Click on each hall to see the details",
    fichaEmpresa: "Company Details",
    resultadosTodos: "All",
    tituloDescripcion: "Profile",
    tituloIndiceFichero: "Additional information",
    tituloIndiceSector: "Sectors",
    tituloIndiceProductos: "Products",
    tituloIndiceActividades: "Activities",
    tituloIndiceDestacados: "Highlights",
    tituloIndiceMarcas: "Trademarks",
    tituloIndiceStands: "Stands",
    tituloIndiceCoexpos: "Co-exhibitors ",
    tituloIndiceCampos: "Additional details",
    tituloIndicePais: "Countries",
    tituloActividad: "Activities",
    tituloProducto: "Products",
    tituloIndiceRepresentadas: "Represented Companies",
    tituloIndiceRepresentadasPor: "Companies that represent ",
    tituloIndicePaisesRepre: "Represented Countries ",
    verEmpresas: "View Companies",
    direccion: "Address:",
    telefono: "Tel:",
    email: "Email:",
    mailto: "Send email",
    web: "Web:",
    video: "Video:",
    verVideo: "Watch video",
    pabellon: "Hall",
    tipoExpo: "MAIN EXHIBITOR",
    tipoCoexpo: "CO-EXHIBITOR",
    tipoRepre: "REPRESENTED",
    tipoMarca: "TRADEMARK",
    paisCatalogo: "Country:",
    txtBusquedas: "Search",
    txtBusquedasAplicadas: "Search by",
    mostrarFavorito: "View favourites",
    txtNoFicha: "Company Details not Available for this Catalogue",
    avisoLegal: "All rights reserved.<br><br>All content included in this application is protected by copyright and may not be reproduced without the prior authorisation of its respective owners.<br><br>This application may not be copied, either wholly or partially, without the prior permission of its IFEMA owners.<br>Copyright &copy; 2014<br><br><strong>IFEMA - Feria de Madrid</strong><br>",
    //avisoLegal1: "All rights reserved.",
    //avisoLegal2:"All content included in this application is protected by copyright and may not be reproduced without the prior authorisation of its respective owners.",
    //avisoLegal3:"This application may not be copied, either wholly or partially, without the prior permission of its IFEMA owners.",
    //avisoLegal4:"Copyright of the application 2014",
    //avisoLegal5: "IFEMA - Feria de Madrid",
    avisoLegalWeb: "www.ifema.es",
    webIfema: "http://www.ifema.es",
    imprLista: "¿Do you want to print all the companies found?",
    imprLista1: "Number of companies found:",
    imprLista2: "¿Do you want to print all companies found or just the first ones?",
    imprListaprimeras: "Print the first ",
    imprListaTodas: "Print all",
    imprCancelar: "Cancel",
    imprFicha: "¿Do you want to print the company's information?",
    imprimir: "Print",
    imprFavoritas: "¿Do you want to print all the companies marked as favourite?",
    imprPlano: "¿Do you want to print the map?",
    imprPabellon: "¿Do you want to print the map?",
    cerrar: "Close",
    textoSinDatos: "Data coming soon"
}
